/**
 * Tauri desktop runtime detection.
 *
 * Tauri v2 only injects `window.__TAURI__` when `app.withGlobalTauri` is
 * enabled in tauri.conf.json. Ours is deliberately OFF: no code reads the
 * global API object (all Tauri access goes through `@tauri-apps/api`
 * imports), and enabling it would expose the full IPC surface as a page
 * global in a webview that renders remote OSINT content.
 *
 * What the packaged app ALWAYS injects is `window.__TAURI_INTERNALS__` —
 * the object `@tauri-apps/api`'s invoke() dereferences (verified against
 * @tauri-apps/api 2.10.1 core.js). Gating on it is therefore exact for
 * every code path that goes on to call invoke(). `__TAURI__` is still
 * accepted so the predicate keeps working if withGlobalTauri is ever
 * turned on.
 */
export function isTauriRuntime(): boolean {
  return (
    typeof window !== 'undefined' &&
    ('__TAURI_INTERNALS__' in window || '__TAURI__' in window)
  );
}
